var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"value":_vm.flexvalue,"label":_vm.label,"dense":_vm.isDense,"clearable":_vm.isClearable},on:{"click:clear":function($event){return _vm.callClear()},"input":function($event){return _vm.updateData()}},model:{value:(_vm.flex),callback:function ($$v) {_vm.flex=$$v},expression:"flex"}})
}
var staticRenderFns = []

export { render, staticRenderFns }